import { Button, Input, Modal } from "antd";
import axios from "axios";
import { useTranslation } from "next-i18next";
import { useRef, useState } from "react";
import styled from "styled-components";
import Image from 'next/image'

export default function UserFeedback (props:{name:string, header?:boolean}) {
  const { t } = useTranslation();

	const [modalOpen, setModalOpen] = useState(false)
	const closeModal = () => setModalOpen(false); 
	const [text, setText] = useState('')
	const [thanks, setThanks] = useState(false)

	const handleConfirm = () => {
		axios.post("/api/common/user-feedback", {text, position:props.name});		
		setThanks(true)
		setTimeout(()=>{
			closeModal();
			setText('')
			setThanks(false);
		}, 1500)
	}

  return <FeedbackCSS>
		<Button onClick={()=>setModalOpen(true)} className={props.header ?  "mainBtn header" : "mainBtn"}>
			<Image src="/images/icon/iconamoon_comment-dots.svg" width={24} height={24} style={{verticalAlign:"bottom"}} alt="" />
			<span className="buttonText">
				&nbsp;{t("Feedback")}
			</span>
		</Button>
		<Modal 
			title={t('We want to make AI STUDIOS bertter for you.')}
			open={modalOpen}
			onCancel={closeModal}
			onOk={handleConfirm}
			okText={t('Submit')}
			cancelText={t('Cancel')}
			okButtonProps={{disabled: thanks || !text.trim()}}
			cancelButtonProps={{disabled: thanks}}
		>
				{!thanks &&
					<div style={{padding:"20px 10px 10px"}}>
						<Input.TextArea value={text} onChange={(e)=>setText(e.target.value)} rows={4} placeholder={t('Help us improve your experience')} />
					</div>
				}
				{thanks &&
					<h1>Thank you !</h1>
				}
		</Modal>
	</FeedbackCSS>;
};


export const FeedbackCSS = styled.div<{ header?: string }>`
	.mainBtn {
		height:40px;
		font-family: Poppins;
		font-weight: 500;
		font-size: 14px;
		padding: 0 10px;
	}
	.mainBtn.header {
		position: absolute;
		right: 60px;
		top : 8px;
	}
	
	.buttonText {
		display: inline;
	}
  @media screen and (max-width: 768px) {
    .buttonText {
			display: none;
		}
		.mainBtn.header {
			position: absolute;
			right: 20px;
			top : 8px;
		}
  }
`;